import { render, staticRenderFns } from "./ExamesHivSifilis.vue?vue&type=template&id=5e01d545"
import script from "./ExamesHivSifilis.vue?vue&type=script&lang=js"
export * from "./ExamesHivSifilis.vue?vue&type=script&lang=js"
import style0 from "./ExamesHivSifilis.vue?vue&type=style&index=0&id=5e01d545&prod&lang=css"
import style1 from "./ExamesHivSifilis.vue?vue&type=style&index=1&id=5e01d545&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports